/**
 * Anzeige der Beteiligten einer Unterhaltung (Postfach, Fallakte).
 *
 * Kundenfeedback 16.09.2026 (zweiter Teil, III): userName enthält Anrede und
 * Titel aus den Stammdaten. In einer Aufzählung wirkte das uneinheitlich
 * („Frau Fr Franziska Grotz", „Herr Rechtsanwalt Tobias Vogel"). Die Zeile
 * nennt deshalb nur Vor- und Nachname und kürzt lange Listen.
 */
export interface ParticipantLike {
  idUser?: number | null
  userName?: string | null
  firstName?: string | null
  lastName?: string | null
  externalName?: string | null
  externalEmail?: string | null
}

export function participantDisplayName (p: ParticipantLike): string {
  const fullName = `${(p.firstName || '').trim()} ${(p.lastName || '').trim()}`.trim()
  return fullName
    || (p.userName || '').trim()
    || (p.externalName || '').trim()
    || (p.externalEmail || '').trim()
}

export interface ParticipantSummary {
  visible: string[]
  hiddenCount: number
  total: number
}

export function summarizeParticipants (participants: ParticipantLike[], limit: number): ParticipantSummary {
  const names = (participants || []).map(p => participantDisplayName(p)).filter(Boolean)
  const visible = names.slice(0, Math.max(0, limit))
  return { visible, hiddenCount: names.length - visible.length, total: names.length }
}
